export const REFETCH_ON_WINDOW_FOCUS = false; // default: true
export const NETWORK_MODE = 'always';
export const STALE_TIME = 1000 * 60 * 10;  // 10 minutes
